import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.556 4.889c-1.645 0-3.2.73-4.637 1.921l-.27.23a14.04 14.04 0 0 0-.489.452L16 7.65l-.16-.158a12.871 12.871 0 0 0-.759-.68c-1.437-1.192-2.992-1.923-4.637-1.923-3.679 0-6.667 2.957-6.667 6.61 0 4.911 3.023 10.154 11.072 15.103a2.209 2.209 0 0 0 2.298.003C25.2 21.653 28.223 16.41 28.223 11.5c0-3.654-2.988-6.611-6.667-6.611Zm0 2.221C24.012 7.11 26 9.078 26 11.5l-.004.269c-.11 3.965-2.653 8.292-9.533 12.643L16 24.7C8.613 20.16 6 15.626 6 11.5c0-2.422 1.987-4.39 4.444-4.39 1.04 0 2.144.52 3.22 1.412.395.327.756.68 1.073 1.034l.195.222.133.163.044.056a1.11 1.11 0 0 0 1.782 0l.102-.13.164-.194c.362-.415.756-.8 1.179-1.152 1.076-.89 2.181-1.41 3.22-1.41Z"
    }, null, -1)
  ])))
}
export default { render: render }